export enum ResearchDashboardSpecialReportsGridBlock {
  Root = 'ResearchDashboardSpecialReportsGrid',
}
